var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.meta.titleBar)?_c('navbar'):_vm._e(),_c('app-main'),(_vm.$route.meta.tabbar)?_c('tabbar'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }